<template>
    <div class="pa-6" style="background-color: #F4F7FE; min-height: 100vh;">
        <div class="d-flex justify-space-between align-center mb-8">
            <div class="d-flex align-center">
               <v-avatar size="80" color="#4318FF" class="elevation-4 mr-4" style="border: 3px solid white;">
                        <v-img :src="urlFoto" alt="Foto de perfil"></v-img>
                    </v-avatar>
                <div>
                    <h1 class="text-h4 font-weight-black" style="color: #1B2559;">Mi Perfil</h1>
                    <p class="subtitle-2 grey--text">Gestiona tu información personal y seguridad</p>
                </div>
            </div>
            <v-btn
                color="#4318FF"
                dark
                large
                elevation="3"
                class="rounded-xl px-6 font-weight-bold"
                @click="cambiarPassword">
                <v-icon left>mdi-shield-key</v-icon>
                Seguridad
            </v-btn>
        </div>

        <v-row>
            <v-col cols="12" md="8">
                <v-card class="rounded-xl pa-2" elevation="0" border>
                    <form-usuario 
                        v-if="usuario.id" 
                        :usuario="usuario" 
                        :bloquear-rol="rolSesion != '1'"
                        @guardado="actualizarDatos" 
                    />
                </v-card>
            </v-col>
            
            <v-col cols="12" md="4">
                <v-card class="rounded-xl pa-6 text-center" elevation="0" border style="height: 100%;">
                    <v-icon size="64" color="#4318FF" class="mb-4">mdi-account-badge-outline</v-icon>
                    <h3 class="text-h6 font-weight-bold mb-2">Estado de Cuenta</h3>
                    <p class="grey--text mb-4">Nivel de acceso:</p>
                    <v-chip :color="usuario.rol == '1' ? '#4318FF' : '#FFB547'" dark label class="font-weight-black px-6">
                        {{ usuario.rol == '1' ? 'ADMINISTRADOR' : 'VENDEDOR' }}
                    </v-chip>
                    
                    <v-divider class="my-6"></v-divider>
                    
                    <div class="text-left px-2">
                        <p class="text-subtitle-2 mb-1" style="color: #1B2559;">Consejo de Seguridad:</p>
                        <p class="text-caption grey--text">
                            No compartas tu contraseña con nadie. Si notas actividad sospechosa, cámbiala de inmediato desde el panel de seguridad.
                        </p>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <v-snackbar v-model="snack" :color="snackColor" rounded="pill" top>
            <v-icon left color="white">mdi-check-circle</v-icon>
            {{ snackMsj }}
        </v-snackbar>
    </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import FormUsuario from '../Usuarios/FormUsuario.vue'

export default {
    name: "MiPerfil",
    components: { FormUsuario },
    data:() => ({
        usuario: {},
        rolSesion: localStorage.getItem('rol'),
        snack: false,
        snackColor: "",
        snackMsj: ""
    }),
    computed: {
       
        urlFoto() {
            return Utiles.generarURL(this.usuario.foto || 'default.png');
        }
    },
    mounted(){
        this.obtenerInformacion()
    },
    methods: {
        cambiarPassword(){
            this.$router.push({ name: 'CambiarPassword' })
        },
        obtenerInformacion(){
            HttpService.obtenerConDatos({
                metodo: 'un_usuario',
                id: localStorage.getItem('idUsuario')
            }, 'usuarios.php')
            .then(resultado => {
                this.usuario = resultado;
            })
        },
        async actualizarDatos(payload) {
            const fd = new FormData();
            fd.append("metodo", "put");
            fd.append("idSolicitante", localStorage.getItem('idUsuario'));
            fd.append("usuario_data", JSON.stringify(payload.datos));

            if (payload.foto) {
                fd.append("foto", payload.foto);
            }

            const res = await HttpService.registrar(fd, "usuarios.php");
            
            if(res === true || (res && res.resultado !== false)) {
                this.snackMsj = "Perfil actualizado correctamente";
                this.snackColor = "success";
                this.snack = true;
                
                localStorage.setItem('rol', payload.datos.rol);
                localStorage.setItem('nombreUsuario', payload.datos.nombre); 
                localStorage.setItem('usuario', payload.datos.usuario);    

                setTimeout(() => location.reload(), 1500);
            } else {
                this.snackMsj = "Error al actualizar perfil";
                this.snackColor = "error";
                this.snack = true;
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/MiPerfil.vue